<template>
  <div>
    <table v-if="rowCategories.length > 0" class="table table-striped">
      <thead>
        <tr>
          <th class="col-md-9">{{ $t('row_categories.list_name') }}</th>
          <th class="col-md-3">{{ $t('row_categories.list_actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="category in rowCategories"
          :key="category.id"
          :class="{success: category.new}"
        >
          <td class="category-name">{{ category.name }}</td>
          <td>
            <button
              type="button"
              class="btn btn-default spaced"
              @click="editCategory(category)"
              data-test="edit-button"
            >
              <span class="glyphicon glyphicon-pencil"></span>
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="setCategoryToDelete(category)"
              data-test="delete-button"
            >
              <span class="glyphicon glyphicon-trash"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p id="emptyRowCategoriesList" v-else>
      {{ $t('row_categories.empty_list') }}
    </p>
    <pagination-component
      id="categories-pagination"
      :current-page="currentPage"
      :page-count="pageCount"
      @select-page="retrieveCategories($event)"
    ></pagination-component>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import PaginationComponent from '../PaginationComponent';

export default {
  name: 'RowCategoriesList',
  components: {
    PaginationComponent
  },
  computed: {
    ...mapState({
      rowCategories: state => state.rowCategoriesModule.rowCategories,
      pageCount: state => state.rowCategoriesModule.pageCount,
      currentPage: state => state.rowCategoriesModule.currentPage
    })
  },
  methods: {
    ...mapMutations('rowCategoriesModule', [
      'setCategoryToDelete',
      'setEditCategory',
      'setCategoryToEdit'
    ]),
    ...mapActions('rowCategoriesModule', ['retrieveRowCategories']),
    retrieveCategories(selectedPage) {
      this.retrieveRowCategories({
        page: selectedPage - 1
      });
    },
    editCategory(category) {
      this.setCategoryToEdit(category);
      this.setEditCategory(true);
    }
  }
};
</script>

<style scoped>
.spaced {
  margin-right: 1em;
}

td {
  text-align: left;
}

td.category-name {
  max-width: 45rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions {
  text-align: right;
}
</style>
<style>
#categories-pagination > .extra-pagination > div.sweet-modal {
  position: absolute;
  left: 300px;
  right: 0px;
  margin-left: 0;
  margin-right: 0px;
  width: 400px;
  overflow: clip;
}
</style>
